define(function(require){
    'use strict';

    var Marionette = require('marionette');
    var template   = require('text!tmpls/parts/top-notice.tpl').default;

    var Model = Backbone.Model.extend();

    return Marionette.ItemView.extend({
        template: template           ,
        className: 'inner-top-notice',

        initialize: function(){
            this.model = new Model();
        },

        show: function(options){
            this.model.set(options);

            this.render();

            // Устанавливаем цвет фона (нужно для handlebars)
            switch(options.color){
                case 'green': this.model.set('green' , true);   break;
                case 'blue' : this.model.set('blue'  , true);   break;
                default     : this.model.set('green' , true);   break;
            }

            app.regionTopNotice.show( this );
            $('body').addClass('top-notice');
        },

        hide: function(){
            $('body').removeClass('top-notice');
        }

    });

});
